import PropTypes from 'prop-types';
import React from 'react';

import WhiteListButtonComponents from '../components/white-list/white-list-button.jsx';

const WhiteListButton = function (props) {
    return (
        <WhiteListButtonComponents
            text={props.text}
            onClick={props.onClick}
        />
    );
};

WhiteListButton.propTypes = {
    onClick: PropTypes.func,
    text: PropTypes.strgin
};

export default WhiteListButton;
